<template>
  <v-sheet color="primary">
    <v-container class="py-0">
      <v-sheet
        width="100%"
        height="104px"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="36px"
          />
        </router-link>

        <div class="d-flex align-center">
          <div>
            <div
              v-for="({ text, to, href, submenu }, key) in menu"
              :key="key"
              class="d-inline-flex"
            >
              <v-btn
                class="
                  text-body-1
                  white--text
                  text-none
                  font-weight-bold
                  px-3
                  py-5
                  mx-lg-3
                  nav-link
                "
                :to="href ? undefined : to"
                :href="href || undefined"
                active-class="nav-link-active"
                tile
                depressed
                text
                v-if="!submenu"
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    :class="
                      `text-body-1
                      white--text
                      text-none
                      font-weight-bold
                      px-3
                      py-5
                      mx-lg-3
                      nav-link ` + (value ? `nav-link-active ` : ``)
                    "
                    active-class="nav-link-active"
                    tile
                    depressed
                    text
                  >
                    {{ text }}
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list class="primary darken-1" tile>
                  <v-list-item
                    v-for="(item, index) in submenu"
                    :to="item.to"
                    :key="index"
                  >
                    <v-list-item-title class="white--text">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-sheet>
</template>

<script>
import { getSocial } from "../../../config";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
    slides() {
      return this.$rest(`slides`).list;
    },
  },
  methods: {
    sa(i) {
      console.log(i);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link {
  border-bottom: 2px solid transparent;
  position: relative;
  transition: all 0.1s linear;
  &:before {
    opacity: 0 !important;
  }
  &.nav-link-active {
    border-bottom: 2px solid #ffffff;
  }
}
</style>
